import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { INoResultFiltersReport } from '@/shared/model/no-result-filters-report.model';

const baseApiUrl = 'api/no-result-filters-reports';

export default class NoResultFiltersReportService {
  public find(id: string): Promise<INoResultFiltersReport> {
    return new Promise<INoResultFiltersReport>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: INoResultFiltersReport): Promise<INoResultFiltersReport> {
    return new Promise<INoResultFiltersReport>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: INoResultFiltersReport): Promise<INoResultFiltersReport> {
    return new Promise<INoResultFiltersReport>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdate(entity: INoResultFiltersReport): Promise<INoResultFiltersReport> {
    return new Promise<INoResultFiltersReport>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
